import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM6.5 4.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.684 8.345a1 1 0 0 1 1.394-.238A5.035 5.035 0 0 0 8 9.035a5.03 5.03 0 0 0 2.922-.928 1 1 0 0 1 1.156 1.633 7.034 7.034 0 0 1-2.753 1.17l2.382 2.383a1 1 0 0 1-1.414 1.414L8 12.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l2.382-2.382A7.03 7.03 0 0 1 3.922 9.74a1 1 0 0 1-.238-1.395Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialOK16 = createIcon(IconComponent);